<template>
  <div>
    <a-modal v-model="visible" title="自定义标签" class="custom__main--div" width="350px" :dialogStyle="{top:'25%'}">
      <div class="content__main--div">
        <a-row>
          <a-col :span="8" class="lable__col">自定义标签:</a-col>
          <a-col :span="15" :offset="1">
            <a-input placeholder="请输入自定义标签" v-model="customTags"/>
          </a-col>
        </a-row>
      </div>
      <template slot="footer">
        <div class="footer__btnGroup--div">
          <a-button type="default" @click="closeModal" class="btn__style">取消</a-button>
          <a-button type="primary" @click="handleOk" class="btn__style">保存</a-button>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
export default {
  name:'CustomTag',
  props:{
    showStaus:{
      type:Boolean
    }
  },
  data(){
    return{
      visible:false,
      customTags:undefined
    }
  },
  watch:{
    showStaus(val){
      console.log(val,"显示状态")
      this.visible = val
    }
  },
  methods:{
    handleOk(){
      this.$emit('save',this.customTags)
      this.closeModal()
    },
    closeModal(){
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
@import "./selectTags.less";
</style>